// extracted by mini-css-extract-plugin
export default {"content_holder":"index_content_holder__CBroH","home_icon":"index_home_icon__a4y59","sub_title":"index_sub_title__jllyJ","export_button":"index_export_button__xyyxE"};